import { render, staticRenderFns } from "./VerbTable.vue?vue&type=template&id=017762ca&scoped=true&"
import script from "./VerbTable.vue?vue&type=script&lang=js&"
export * from "./VerbTable.vue?vue&type=script&lang=js&"
import style0 from "./VerbTable.vue?vue&type=style&index=0&id=017762ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017762ca",
  null
  
)

export default component.exports